import { Component, inject, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { DynamicPageElement } from '../../../services/dynamic-pages/dynamic-pages.service';
import { DynamicPageDcBaseComponent } from '../dynamic-page-dc-base/dynamic-page-dc-base.component';
import { TranslateService } from '@ngx-translate/core';
import { LanguageConfigService } from '../../../../../services/language-config/language-config.service';
@Component({
  selector: 'lib-dynamic-page-dc-heading-text',
  standalone: false,
  templateUrl: './dynamic-page-dc-heading-text.component.html',
  styleUrl: './dynamic-page-dc-heading-text.component.scss'
})
export class DynamicPageDcHeadingTextComponent extends DynamicPageDcBaseComponent {
  protected translateService = inject(TranslateService);
  protected languageConfigService = inject(LanguageConfigService);

  currentLang = this.translateService.currentLang;

  translate = false;

  translateLangs = this.languageConfigService
    .getLanguages()
    .filter(l => l.enabled)
    .map(l => l.short);

  elementId = 'heading-text';
  fields = {
    translate: false,
    title: '<h3>NEW TITLE</h3>',
    text: 'FREE TEXT',
    background: '#fafafa',
    marginTop: 0,
    marginRight: 0,
    marginBottom: 0,
    marginLeft: 0,
    paddingTop: 15,
    paddingRight: 15,
    paddingBottom: 15,
    paddingLeft: 15
  };

  changeTranslate() {
    this.translate = this.element.fields.translate;
    const translatableFields = ['title', 'text'];
    if (this.translate) {
      translatableFields.forEach(field => {
        let currentValue = this.element.fields[field];

        if (typeof currentValue === 'string' || !currentValue) {
          currentValue = {
            value: currentValue || '',
            i18n: {}
          };
        }

        this.translateLangs.forEach((lang: string) => {
          if (!currentValue.i18n[lang]) {
            currentValue.i18n[lang] = currentValue.value;
          }
        });

        this.element.fields[field] = currentValue;
      });
    } else {
      translatableFields.forEach(field => {
        const currentValue = this.element.fields[field];

        if (currentValue && typeof currentValue === 'object' && 'value' in currentValue) {
          this.element.fields[field] = {
            ...currentValue,
            value: currentValue.value
          };
        }
      });
    }
  }
}
